import React, { memo } from 'react';
import { Text, View, Pressable, Image, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, __WEB__ } from '../../../constants/styles';
import ArrowRight from '../display/arrow_right';

const IconButton = memo((props) => {
  function renderValue() {
    if (!props.value && !props.renderValue) return null;
    if (props.renderValue) return <View style={styles.valueContainer}>{props.renderValue()}</View>;

    return (
      <Text
        style={[styles.iconButtonValueText, props.disabled ? styles.disabledText : null]}
        numberOfLines={1}
      >
        {props.value}
      </Text>
    );
  }

  const borderStyles = {};
  if (props.noTopBorder) borderStyles.borderTopWidth = 0;
  if (props.noBottomBorder) borderStyles.borderBottomWidth = 0;

  const renderedValue = renderValue();

  return (
    <Pressable
      style={[styles.iconButton, borderStyles, props.containerStyle]}
      onPress={props.onPress}
      disabled={!!props.disabled}
    >
      {!props.noIcon && (
        <Image
          style={[
            styles.iconButtonIcon,
            props.iconStyle,
            props.disabled ? styles.disabledIcon : null,
          ]}
          source={props.imageSource}
          resizeMode="contain"
        />
      )}
      <View style={{ flex: 1, flexDirection: 'row', alignItems: 'center' }}>
        <Text
          style={[
            styles.iconButtonLabelText,
            props.disabled ? styles.disabledText : null,
            props.labelStyle,
            !renderedValue ? { flex: 1 } : null,
          ]}
          numberOfLines={1}
        >
          {props.label}
        </Text>
        {renderedValue}
      </View>
      {!props.hideArrow && (
        <View style={{ marginLeft: 25 }}>
          <ArrowRight disabled={!!props.disabled} />
        </View>
      )}
    </Pressable>
  );
});

const styles = StyleSheet.create({
  iconButton: {
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 1,
    borderTopWidth: 1,
    borderColor: COLOR.accent,
    paddingLeft: __WEB__ ? 35 : 25,
    paddingRight: __WEB__ ? 45 : 25,
    paddingVertical: 15,
  },
  iconButtonIcon: {
    width: 20,
    height: 20,
  },
  iconButtonLabelText: {
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    marginLeft: 20,
    minWidth: 150,
    color: COLOR.text,
  },
  iconButtonValueText: {
    flex: 1,
    ...FONT.regular,
    fontSize: FONT_SIZE.small,
    color: COLOR.textLight,
    textAlign: 'right',
    paddingLeft: 30,
  },
  valueContainer: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  disabledText: {
    color: COLOR.textDisabled,
  },
  disabledIcon: {
    tintColor: COLOR.textDisabled,
  },
});

IconButton.displayName = 'IconButton';
export default IconButton;
